module.exports = __webpack_public_path__ + "media/assets/svgs/logoWhite-e051ffef3bef018ef0ca59c7c8c567a7.svg";